import { createPageAnalyticsFn } from 'src/libs/Analytics';

interface CandidateManagementLinkAnalyticEvents {
  event: 'searched_location_pressed';
  attributes: {
    searchLocationId: string[];
    locationIdSelected: string;
    filterSelection: 'Selected' | 'Deselected';
  };
}

export const createPageAnalytics = createPageAnalyticsFn<
  CandidateManagementLinkAnalyticEvents,
  never
>({
  siteSubsection: 'candidate',
});
